import React, { FC, useContext, useState } from "react";
import { Form, Alert, Row, Col } from "react-bootstrap";
import CalendarSelect from "../../../components/form/CalendarSelect";
import { useConfig } from "../../../hooks/useConfig";
import { CalendarType } from "../../../types/EventType";
import { OptionType } from "../../../types/CommonType";
import { AuthContext } from "../../../providers/AuthContextProvider";

interface Props {

}

const CalendarTab: FC<Props> = ({ }) => {
    const { getConfig } = useConfig();
    const [selectedCalendar, setSelectedCalendar] = useState<CalendarType | null>(null);
    const { user } = useContext(AuthContext)

    return (
        <>

            <Row>
                <Col lg={12}>
                    <Alert variant="info">
                        <i className="bi bi-info-circle-fill"></i> Selecione a agenda que deseja configurar.
                    </Alert>
                </Col>
                <Col lg={4}>
                    <Form.Group className="mb-3" controlId="name">
                        <Form.Label>Agenda</Form.Label>
                        <CalendarSelect
                            name="calendar"
                            value={null}
                            onChange={(o: OptionType) => {
                                setSelectedCalendar((user?.calendars || []).find(c => c.id.toString() === o.value.toString()) || null);                                
                            }}
                            placeholder="Selecione uma agenda"
                            calendars={user?.calendars || []}
                        />
                    </Form.Group>
                </Col>
                {selectedCalendar !== null && (
                    <Col lg={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>URL do iCalendar (ICS)</Form.Label>
                            <Form.Control
                                type="text"
                                readOnly
                                value={
                                    selectedCalendar !== null && selectedCalendar.ics_token ?
                                        `${getConfig('SITE_URL')}/api/events.ics?token=${selectedCalendar ? selectedCalendar.ics_token : ''}`
                                        : 'Não configurado. Entre em contato com o suporte.'
                                }
                            />
                            <Form.Text className="text-muted">
                                Copie e cole essa URL em seu aplicativo de calendário favorito. <br />
                                Google Calendar: <a href="https://support.google.com/calendar/answer/37100?hl=pt-BR" target="_blank" rel="noreferrer">https://support.google.com/calendar/answer/37100?hl=pt-BR</a><br />
                                Apple Calendar: <a href="https://support.apple.com/pt-br/guide/calendar/icl1022/16.0/mac/26" target="_blank" rel="noreferrer">https://support.apple.com/pt-br/guide/calendar/icl1022/16.0/mac/26</a><br />                                
                            </Form.Text>
                        </Form.Group>
                    </Col>
                )}
            </Row>
        </>
    )
}

export default CalendarTab;